import { NAME } from './constants';

export const SET_ACTIVE_AUTH_SITE = `${NAME}/SET_ACTIVE_AUTH_SITE`;

export const SET_USER_CONFIG_TEMPLATES = `${NAME}/SET_USER_CONFIG_TEMPLATES`;
export const FETCH_USER_CONFIG_TEMPLATES = `${NAME}/FETCH_USER_CONFIG_TEMPLATES`;

export const SET_TEMPLATE_LIST_IS_LOADING = `${NAME}/SET_TEMPLATE_LIST_IS_LOADING`;

export const FETCH_USER_LIST = `${NAME}/FETCH_USER_LIST`;
export const SET_USER_LIST = `${NAME}/SET_USER_LIST`;

export const FETCH_ALL_USER_LIST = `${NAME}/FETCH_ALL_USER_LIST`;
export const SET_ALL_USER_LIST = `${NAME}/SET_ALL_USER_LIST`;

export const FETCH_USER_DETAILS = `${NAME}/FETCH_USER_DETAILS`;
export const VALIDATE_PARTIAL_USER_DETAILS = `${NAME}/VALIDATE_PARTIAL_USER_DETAILS`;
export const UPDATE_USER_DNS = `${NAME}/UPDATE_USER_DNS`;

export const ADD_USER_DETAILS = `${NAME}/ADD_USER_DETAILS`;
export const EDIT_USER_DETAILS = `${NAME}/EDIT_USER_DETAILS`;
//export const SET_USER_DETAILS = `${NAME}/SET_USER_DETAILS`;
export const UPDATE_USER_DETAILS = `${NAME}/UPDATE_USER_DETAILS`;

export const SET_VALIDATION_ERRORS = `${NAME}/SET_VALIDATION_ERRORS`;
export const CLEAR_VALIDATION_ERRORS = `${NAME}/CLEAR_VALIDATION_ERRORS`;
export const SET_VALIDATED_PATHS = `${NAME}/SET_VALIDATED_PATHS`;

export const SET_STAGED_EDITS = `${NAME}/SET_STAGED_EDITS`;
export const CLEAR_STAGED_EDITS = `${NAME}/CLEAR_STAGED_EDITS`;

export const SET_USER_FILTERS = `${NAME}/SET_USER_FILTERS`;

export const SET_DETAIL_MODE = `${NAME}/SET_DETAIL_MODE`;
export const RESET_USER_DATA = `${NAME}/RESET_USER_DATA`;

export const SET_IS_LOADING = `${NAME}/SET_IS_LOADING`;
export const SET_IS_SAVING = `${NAME}/SET_IS_SAVING`;

export const ACTIVATE_USER = `${NAME}/ACTIVATE_USER`;
export const DEACTIVATE_USER = `${NAME}/DEACTIVATE_USER`;

export const SELECT_USER = `${NAME}/SELECT_USER`;
export const UNSELECT_USER = `${NAME}/UNSELECT_USER`;

export const SELECT_ALL_USERS = `${NAME}/SELECT_ALL_USERS`;
export const UNSELECT_ALL_USERS = `${NAME}/UNSELECT_ALL_USERS`;

export const RESET_PASSWORD = `${NAME}/RESET_PASSWORD`;
export const ACT_AS_USER = `${NAME}/ACT_AS_USER`;

export const FETCH_USER_DEVICES = `${NAME}/FETCH_USER_DEVICES`;
export const VERIFY_USER_DEVICE = `${NAME}/VERIFY_USER_DEVICE`;
export const REMOVE_USER_DEVICE = `${NAME}/REMOVE_USER_DEVICE`;
export const SET_USER_DEVICES = `${NAME}/SET_USER_DEVICES`;
export const CLEAR_USER_DEVICES = `${NAME}/CLEAR_USER_DEVICES`;
export const FETCH_USER_HISTORY = `${NAME}/FETCH_USER_HISTORY`;
export const SET_USER_HISTORY = `${NAME}/SET_USER_HISTORY`;
export const CLEAR_USER_HISTORY = `${NAME}/CLEAR_USER_HISTORY`;
export const SET_USER_HISTORY_IS_LOADING = `${NAME}/SET_USER_HISTORY_IS_LOADING`;
export const SET_SELECT_MODE = `${NAME}/SET_SELECT_MODE`;

export const SET_BULK_APPLY_PATHS = `${NAME}/SET_BULK_APPLY_PATHS`;
export const BULK_EDIT_USER = `${NAME}/BULK_EDIT_USER`;
export const BULK_ACTIVATE_USER = `${NAME}/BULK_ACTIVATE_USER`;
export const BULK_DEACTIVATE_USER = `${NAME}/BULK_DEACTIVATE_USER`;
